module.exports = __webpack_public_path__ + "img/headphone-2.b2246542.jpg";